<script lang="ts">
	import { cn } from "#lib/web-ui/ui/utils.js";
	import type { Snippet } from "svelte";
	import { Section, SectionHeader, type SectionTheme } from "#lib/web-ui/primitives/index.js";

	interface Props {
		title?: string;
		label?: string;
		description?: string;
		secondaryText?: string;
		image?: string;
		imageAlt?: string;
		imagePosition?: "left" | "right";
		theme?: SectionTheme;
		children?: Snippet;
		class?: string;
	}

	let {
		title = "A Disciplined Approach to Real Estate Investing",
		label,
		description = "We combine deep market knowledge with institutional-grade analysis to identify properties where active management and strategic improvements can drive above-market returns for our partners.",
		secondaryText,
		image,
		imageAlt = "",
		imagePosition = "right",
		theme = "light",
		children,
		class: className
	}: Props = $props();
</script>

<Section {theme} class={className}>
	<div
		class={cn(
			"grid items-center gap-12 lg:grid-cols-2 lg:gap-16",
			imagePosition === "left" && "lg:[&>*:first-child]:order-2"
		)}
	>
		<div>
			<SectionHeader {label} {title} subtitle={description} align="left" class="mb-0" />
			{#if secondaryText}
				<p class="text-muted-foreground mt-4 text-lg/relaxed">
					{secondaryText}
				</p>
			{/if}
			{#if children}
				<div class="mt-8">
					{@render children()}
				</div>
			{/if}
		</div>

		<div class="aspect-[4/3] overflow-hidden rounded-lg">
			{#if image}
				<img
					src={image}
					alt={imageAlt}
					class="h-full w-full object-cover"
					width="600"
					height="450"
					loading="lazy"
				/>
			{:else}
				<div class="bg-muted flex h-full w-full items-center justify-center">
					<div class="text-muted-foreground text-center">
						<svg
							class="mx-auto size-12"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1"
							stroke="currentColor"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909M3.75 21h16.5A2.25 2.25 0 0 0 22.5 18.75V5.25A2.25 2.25 0 0 0 20.25 3H3.75A2.25 2.25 0 0 0 1.5 5.25v13.5A2.25 2.25 0 0 0 3.75 21Z"
							/>
						</svg>
						<p class="mt-2 text-sm">Image placeholder</p>
					</div>
				</div>
			{/if}
		</div>
	</div>
</Section>
